import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MuralView from '../views/MuralView.vue'
import WaitView from '../views/WaitView.vue'

let routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/viewer',
    name: 'viewer',
    component: MuralView
  },
  {
    path: '/wait',
    name: 'wait',
    component: WaitView
  },
]

let router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
